"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaAnswerReducer = exports.kansaAnswerActions = exports.TYPES = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Answer';

// アクションタイプ
const TYPES = exports.TYPES = {
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  FIX_CONDITIONS: PREFIX + 'fixCondtions',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  SET_SEARCH_TRAIL_RESULT: PREFIX + 'SetSearchTrailResult',
  SET_SEARCH_BCP_TRAIL_RESULT: PREFIX + 'SetSearchBcpTrailResult',
  SET_ENTRY_RESULT: PREFIX + 'SetEntryResult',
  SET_ENTRY: PREFIX + 'SetEntry',
  SET_ENTRIES: PREFIX + 'SetEntries',
  SET_CONTENT: PREFIX + 'SetContent',
  SET_REGISTER_DT: PREFIX + 'SetRegisterDt',
  SET_RETURN_BTN: PREFIX + 'SetReturnBtn',
  SET_INIT_NENDO: PREFIX + 'SetInitNendo',
  SET_KANSA_INFO: PREFIX + 'SetKansaInfo',
  CHANGE_NENDO: PREFIX + 'ChangeNendo',
  CHANGE_EVI_STATUS: PREFIX + 'changeEviStatus',
  CHANGE_EVI_STATUS_ALL: PREFIX + 'changeEviStatusAll',
  CHANGE_PUSH_FLG: PREFIX + 'ChangePushFlg',
  SET_MAIL_ERR_MSG: PREFIX + 'SetMailErrMsg',
  SET_KANSA_TGT_JIGYO_BASIC_INFO: PREFIX + 'SetkansaTgtJigyoBasicInfo',
  GO_MAIN: PREFIX + 'GoMain',
  GO_REFER: PREFIX + 'GoRefer',
  GO_REGISTER: PREFIX + 'GoRegister',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  REFER: 'refer',
  REGISTER: 'register',
  RESULT: 'result',
  ZENNENDO: 'zennendo',
  PROGRESS_TO_ANSWER_REFER: 'progressToAnswerRefer',
  // 監査進捗状況：監査回答表示
  PROGRESS_TO_ANSWER_REGISTER: 'progressToAnswerRegister' // 監査進捗状況：監査回答登録
};
const INIT_CONDITION = Object.freeze({
  gyomuCdAvail: _CodeConsts.CODE.AUTH_GYOMU_CD.CODE_3,
  // 権限制御業務内容コード
  gyomuCd: _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1,
  kansaTgtNendo: '',
  kansaTheme: '',
  kansaKaishaCd: '',
  kansaBumonCd: '',
  kansaBumonNm: '',
  hikansaKaishaCd: '',
  hikansaBumonCd: '',
  hikansaBumonNm: '',
  kansaTgtJigyoNm: '',
  tantoOnlyFlg: false,
  answerStatus: _CodeConsts.CODE.KANSA_ANS_STS.CODE_0,
  kaishaCd: '',
  soshikiCd: '',
  userNm: '',
  shokuiCd: ''
});

// 初期状態
const INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  isProgress: false,
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  soshikiShowAll: false,
  searchConditions: _objectSpread({}, INIT_CONDITION),
  fixedConditions: _objectSpread({}, INIT_CONDITION),
  searchResult: [],
  searchTrailResult: [],
  searchBcpTrailResult: [],
  entryResult: [],
  listState: {},
  bcpListState: {},
  eviNo: '',
  eviDocNm: '',
  kansaInfo: {
    kansaTgtNendo: '',
    kansaTgtJigyoId: ''
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  trailDocName: '',
  search: false,
  entries: {
    msg: '',
    kakuninKekka: '',
    kakuninHosoku: '',
    hakkenjikoBunrui: _CodeConsts.CODE.KANSA_HKN_BNR.KBN,
    hakkenjiko: '',
    seijukudoHyokaRst: '',
    pushFlg: true
  },
  mailErrMsg: '',
  previousEntries: {
    msg: ''
  },
  selectNendo: {
    kansaTgtNendo: '',
    kansaTgtNendoNm: '',
    kansaThemeNm: ''
  },
  returnBtn: '',
  kansaTgtNendoMaxPoints: '',
  kansaTgtJigyoBasicInfo: {
    kansaTgtNendoNm: '',
    kansaThemeNm: '',
    kansaBumonNm: '',
    kansaSekinishaNm: '',
    kansaTgtJigyoNm: '',
    hikansaSekinishaNm: ''
  },
  allRegFlg: false
};
const kansaAnswerActions = exports.kansaAnswerActions = (0, _reduxActions.createActions)({
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEARCH_TRAIL_RESULT]: function () {
    return {
      searchTrailResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEARCH_BCP_TRAIL_RESULT]: function () {
    return {
      searchBcpTrailResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY_RESULT]: function () {
    return {
      resultData: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSA_INFO]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0],
      dispContent: arguments.length <= 1 ? undefined : arguments[1],
      isProgress: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.GO_REFER]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_REGISTER]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_RETURN_BTN]: function () {
    return {
      btn: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      dataId: arguments.length <= 0 ? undefined : arguments[0],
      key: arguments.length <= 1 ? undefined : arguments[1],
      value: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_REGISTER_DT]: function () {
    return {
      dt: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PUSH_FLG]: function () {
    return {
      flg: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_MAIL_ERR_MSG]: function () {
    return {
      mailErrMsg: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 初期値を返却
  [TYPES.SET_INIT_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1],
      preparation: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.CHANGE_EVI_STATUS]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      eviStatus: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_EVI_STATUS_ALL]: function () {
    return {
      eviStatus: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO]: function () {
    return {
      kansaTgtJigyoBasicInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.FIX_CONDITIONS, TYPES.RESET_PAGING, TYPES.CLEAR);
const kansaAnswerReducer = exports.kansaAnswerReducer = (0, _reduxActions.handleActions)({
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => {
    const _action$payload$share = action.payload.shareCondition,
      rest = _extends({}, (_objectDestructuringEmpty(_action$payload$share), _action$payload$share));
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), rest)
    });
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.FIX_CONDITIONS]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    fixedConditions: _objectSpread({}, state.searchConditions)
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    search: false
  }),
  [TYPES.SET_SEARCH_TRAIL_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchTrailResult: action.payload.searchTrailResult,
    search: false
  }),
  [TYPES.SET_SEARCH_BCP_TRAIL_RESULT]: (state, action) => {
    const newListState = {};
    let allRegFlg = true;
    action.payload.searchBcpTrailResult.forEach(data => {
      newListState[data.bcmKaishaSoshikiCd + data.soshikiNmFull + data.bcpTgtJigyoCd + data.documentKindNm] = _objectSpread(_objectSpread({}, data), {}, {
        isChange: false,
        eviStatus: data.eviNo ? true : false,
        eviStatusOrg: data.eviNo ? true : false
      });
      if (allRegFlg) {
        allRegFlg = data.eviNo ? true : false;
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchBcpTrailResult: action.payload.searchBcpTrailResult,
      search: false,
      bcpListState: newListState,
      allRegFlg: allRegFlg
    });
  },
  [TYPES.CHANGE_EVI_STATUS]: (state, action) => {
    let newListState = Object.assign({}, state.bcpListState);
    const {
      eviStatusOrg
    } = newListState[action.payload.key];
    newListState[action.payload.key] = _objectSpread(_objectSpread({}, newListState[action.payload.key]), {}, {
      isChange: action.payload.eviStatus !== eviStatusOrg,
      eviStatus: action.payload.eviStatus,
      eviStatusOrg: eviStatusOrg
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      bcpListState: newListState
    });
  },
  [TYPES.CHANGE_EVI_STATUS_ALL]: (state, action) => {
    const newListState = Object.assign({}, state.bcpListState);
    state.searchBcpTrailResult.forEach(data => {
      const {
        eviStatusOrg
      } = newListState[data.bcmKaishaSoshikiCd + data.soshikiNmFull + data.bcpTgtJigyoCd + data.documentKindNm];
      newListState[data.bcmKaishaSoshikiCd + data.soshikiNmFull + data.bcpTgtJigyoCd + data.documentKindNm] = _objectSpread(_objectSpread({}, newListState[data.bcmKaishaSoshikiCd + data.soshikiNmFull + data.bcpTgtJigyoCd + data.documentKindNm]), {}, {
        isChange: action.payload.eviStatus !== eviStatusOrg,
        eviStatus: action.payload.eviStatus,
        eviStatusOrg: eviStatusOrg
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      bcpListState: newListState
    });
  },
  [TYPES.SET_ENTRY_RESULT]: (state, action) => {
    let newKansaTgtNendoMaxPoints = '';
    const newListState = {};
    action.payload.resultData.forEach((data, index) => {
      newListState[data.chosaNo] = {
        isChange: false,
        chosaNo: data.chosaNo,
        chosaColumnCd: data.chosaColumnCd,
        kakuninJiko: data.kakuninJiko === null ? '' : data.kakuninJiko,
        kakushoExp: data.kakushoExp === null ? '' : data.kakushoExp,
        kakuninKekkaCd: data.kakuninKekkaCd,
        kakuninKekkaCdOrg: data.kakuninKekkaCd,
        kakuninHosoku: data.kakuninHosoku === null ? '' : data.kakuninHosoku,
        kakuninHosokuOrg: data.kakuninHosoku === null ? '' : data.kakuninHosoku,
        hakkenjikoBunruiCd: data.hakkenjikoBunruiCd,
        hakkenjikoBunruiCdOrg: data.hakkenjikoBunruiCd,
        hakkenjiko: data.hakkenjiko === null ? '' : data.hakkenjiko,
        hakkenjikoOrg: data.hakkenjiko === null ? '' : data.hakkenjiko,
        seijukudoHyoka: data.seijukudoHyoka === null ? '' : data.seijukudoHyoka,
        seijukudoHyokaOrg: data.seijukudoHyoka === null ? '' : data.seijukudoHyoka,
        standardPoints: data.standardPoints,
        maxPoints: data.maxPoints,
        basicAddpointKbnCd: data.basicAddpointKbnCd,
        dispFlg: data.dispFlg,
        points: data.points,
        referencePoints: '',
        insert: data.ansChosaNo === null || data.ansChosaNo === '' ? true : false
      };
      if (index === 0) {
        newKansaTgtNendoMaxPoints = data.maxPoints;
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      entryResult: action.payload.resultData,
      listState: newListState,
      kansaTgtNendoMaxPoints: newKansaTgtNendoMaxPoints
    });
  },
  [TYPES.SET_KANSA_INFO]: (state, action) => {
    const {
      kansaInfo,
      dispContent,
      isProgress
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo,
      dispContent,
      isProgress
    });
  },
  [TYPES.GO_REFER]: (state, action) => {
    const {
      kansaInfo
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo,
      dispContent: CONTENTS.REFER
    });
  },
  [TYPES.GO_REGISTER]: (state, action) => {
    const {
      kansaInfo
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo,
      dispContent: CONTENTS.REGISTER
    });
  },
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread({}, state.fixedConditions),
    dispContent: CONTENTS.MAIN,
    search: action.payload.search
  }),
  [TYPES.RESET_PAGING]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      soshikiShowAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE),
  [TYPES.SET_RETURN_BTN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      returnBtn: action.payload.btn
    });
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    const newListState = Object.assign({}, state.listState);
    if (action.payload.key === 'kakuninKekkaCd') {
      const {
        kakuninKekkaCdOrg
      } = newListState[action.payload.dataId];
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        isChange: action.payload.value !== kakuninKekkaCdOrg,
        kakuninKekkaCd: action.payload.value,
        kakuninKekkaCdOrg: kakuninKekkaCdOrg
      });
    }
    if (action.payload.key === 'kakuninHosoku') {
      const {
        kakuninHosokuOrg
      } = newListState[action.payload.dataId];
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        isChange: action.payload.value !== kakuninHosokuOrg,
        kakuninHosoku: action.payload.value,
        kakuninHosokuOrg: kakuninHosokuOrg
      });
    }
    if (action.payload.key === 'hakkenjikoBunruiCd') {
      const {
        hakkenjikoBunruiCdOrg
      } = newListState[action.payload.dataId];
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        isChange: action.payload.value !== hakkenjikoBunruiCdOrg,
        hakkenjikoBunruiCd: action.payload.value,
        hakkenjikoBunruiCdOrg: hakkenjikoBunruiCdOrg
      });
    }
    if (action.payload.key === 'hakkenjiko') {
      const {
        hakkenjikoOrg
      } = newListState[action.payload.dataId];
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        isChange: action.payload.value !== hakkenjikoOrg,
        hakkenjiko: action.payload.value,
        hakkenjikoOrg: hakkenjikoOrg
      });
    }
    if (action.payload.key === 'seijukudoHyoka') {
      const {
        seijukudoHyokaOrg
      } = newListState[action.payload.dataId];
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        isChange: action.payload.value !== seijukudoHyokaOrg,
        seijukudoHyoka: action.payload.value,
        seijukudoHyokaOrg: seijukudoHyokaOrg
      });
    }
    if (action.payload.key === 'referencePoints') {
      newListState[action.payload.dataId] = _objectSpread(_objectSpread({}, newListState[action.payload.dataId]), {}, {
        referencePoints: action.payload.value
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_REGISTER_DT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      registerDt: action.payload.dt
    });
  },
  [TYPES.CHANGE_PUSH_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        pushFlg: action.payload.flg
      })
    });
  },
  [TYPES.SET_MAIL_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      mailErrMsg: action.payload.mailErrMsg
    });
  },
  [TYPES.CHANGE_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectNendo: selectNendo,
      selectThemeNm: selectThemeNm,
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaTheme: selectThemeNm
      })
    });
  },
  [TYPES.SET_INIT_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm,
      preparation
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectNendo: selectNendo,
      selectThemeNm: selectThemeNm,
      preparation: preparation,
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaTheme: selectThemeNm
      })
    });
  },
  [TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaTgtJigyoBasicInfo: action.payload.kansaTgtJigyoBasicInfo
    });
  }
}, INIT_STATE);